import { cn } from '@mntn-dev/ui-utilities'
import { Button, type ButtonProps } from '../../buttons/button.tsx'
import { useFormFooterContext } from './form-footer-context.ts'

export type FormModalCancelButtonProps = Pick<
  ButtonProps,
  | 'children'
  | 'dataTestId'
  | 'dataTrackingId'
  | 'onClick'
  | 'disabled'
  | 'loading'
  | 'readonly'
  | 'iconLeft'
  | 'iconRight'
  | 'className'
  | 'size'
>

export const FormModalCancelButton = ({
  children,
  className,
  ...buttonProps
}: FormModalCancelButtonProps) => {
  const { orientation } = useFormFooterContext()
  return (
    <Button
      {...buttonProps}
      variant="text"
      size={orientation === 'vertical' ? 'sm' : 'md'}
      className={cn(
        {
          'w-full': orientation === 'vertical',
          'w-1/2': orientation === 'horizontal',
        },
        className
      )}
    >
      {children}
    </Button>
  )
}
